import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  // {
  //   path: '/',
  //   name: 'Login',
  //   redirect: '/login',
  //   component: () => import('../views/login/Login.vue'),
  //   children:[
  //     {
  //       path: '/login',
  //       name: 'Login',
  //       // route level code-splitting
  //       // this generates a separate chunk (about.[hash].js) for this route
  //       // which is lazy-loaded when the route is visited.
  //       component: () => import(/* webpackChunkName: "about" */ '../views/login/Login.vue')
  //     },
  //   ]
  // },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/home/Home.vue'),
  },
  {
    path: '/login',
    name: 'Home',
    component: () => import('../views/login/Login.vue'),
  },
  {
    path: '/announcement',
    name: 'announcement',
    component: () => import('../views/announcement/announcement.vue'),
  },
  {
    path: '/announcementDetail',
    name: 'announcementDetail',
    component: () => import('../views/announcement/announcementDetail.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/about/about.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/contact/contact.vue'),
  },
  {
    path: '/apply',
    name: 'apply',
    component: () => import('../views/apply/apply.vue'),
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('../views/details/details.vue'),
  },
  {
    path: '/certificate',
    name: 'certificate',
    component: () => import('../views/certificate/certificate.vue'),
  },
  {
    path: '/qualification',
    name: 'qualification',
    component: () => import('../views/qualification/qualification.vue'),
  },
  {
    path: '/personal',
    name: 'personal',
    component: () => import('../views/personal/personal.vue'),
  },
]

const router = new VueRouter({
  routes
})

// 挂载路由导航守卫,to表示将要访问的路径，from表示从哪里来，next是下一个要做的操作 next('/login')强制跳转login
router.beforeEach((to, from, next) => {
  // // 访问登录页，放行
  if (to.path === '/login') return next()

  if(from.name == 'Perfect') return false
  // // 获取token
  // const tokenStr = window.sessionStorage.getItem('token')
  // // 没有token, 强制跳转到登录页
  // if (!tokenStr) return next('/login')
  next()
})

export default router
